'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.WidgetTypes = void 0;
(function (WidgetTypes) {
    WidgetTypes["IMAGE_CARD_INFO"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard.ImageCardInfo";
    WidgetTypes["LOTTIE_INFO_LAYOUT_CARD"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.LotteInfoLayoutCard";
    WidgetTypes["LOTTIE_INFO_LAYOUT_WITH_BUTTON_CARD"] = "LottieInfoLayoutWithButtonCard";
    WidgetTypes["GRID_LAYOUT"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget";
    WidgetTypes["FULLWIDTH_BUTTON"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.FullWidthButton";
    WidgetTypes["TEXT_BUTTON_WITH_ICON"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.TextButtonWithIcon";
    WidgetTypes["TEXT"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.Text";
    WidgetTypes["RESTAURANT_CARD"] = "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle";
    WidgetTypes["RENDER_HTML"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.HTMLContent";
    WidgetTypes["MASTHEAD"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.Masthead";
    WidgetTypes["DISCOVER_MILESTONE_WIDGET"] = "type.googleapis.com/swiggy.presentation.food.v2.DiscoverMilestoneWidget";
    WidgetTypes["CTA_BUTTON_WIDGET"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.CtaButtonWidget";
    WidgetTypes["MASTHEAD_PRESEARCH"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.MastheadPreSearch";
    WidgetTypes["APP_CARDS"] = "type.googleapis.com/swiggy.gandalf.widgets.v2.AppCards";
    WidgetTypes["BRAND_CONTENT"] = "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent";
    WidgetTypes["DEFAULT"] = "default";
})(exports.WidgetTypes || (exports.WidgetTypes = {}));
//# sourceMappingURL=index.js.map
